export default function convertImage (imageData, imageType) {
    const arrayBufferView = new Uint8Array(imageData);
    const blob = new Blob([arrayBufferView], { type: imageType });
    const urlCreator = window.URL || window.webkitURL;
    const url = urlCreator.createObjectURL(blob);
    return { url, blob };
};